<template>
  <div v-if="$store.getters.loading"></div>
  <div v-else>
    <div v-if="!personal" style="display: flex; align-items: end; justify-content: end;">
      <v-text-field v-if="esWizardJugadores" v-model="search" label="nombre/apellido/dni/pasaporte"></v-text-field>
      <v-text-field v-else v-model="search" label="nombre/apellido/dni/pasaporte"></v-text-field>
      <v-btn color="primary" elevation="2" @click="buscarJugador">
        Buscar
      </v-btn>
    </div>
    <template>
      <DialogConfirmationPlayerFinal title="Ha seleccionado la misma persona"
        text="Porfavor seleccione una persona distinta" ref="DialogConfirmationPlayerFinalRef"
        :useAction="false" :executeFunction="() => { console.log('funcion ejecutada') }">
      </DialogConfirmationPlayerFinal>
      <template v-if="items.length > 0 && selectedPlayer == null">
        <v-data-table :headers="headers" :items="items" :pagination.sync="pagination"
          @update:pagination="onPaginationChange" :rows-per-page-items="[5, 10, 20]"
          :total-items="pagination.totalItems" @pagination="console.log('hola')" class="elevation-1">
          <template v-slot:items="props">
            <td>{{ props.item.player.firstName }}</td>
            <td>{{ props.item.player.lastName }}</td>
            <td>{{ props.item.player.dni }}</td>
            <td>{{ props.item.player.pasaporte }}</td>
            <td>{{ props.item.player.country.name }}</td>
            <td>{{ props.item.player.pk }}</td>
            <td v-if="!esWizardJugadores">{{ props.item.player.rolDisplay }}</td>

            <td>
              <SelectPlayerActionButton :player="props.item" @player-selected="handlePlayerSelected" />
            </td>
          </template>
        </v-data-table>

      </template>
    </template>
    <template v-if="selectedPlayer !== null">
      <v-card>
        <v-layout row wrap>
          <v-flex xs3 md2 pt-4 pl-2 ml-2 pb-4 v-if="personal">
            <v-img :src="personal.photo" max-height="150px" contain v-if="personal.photo"></v-img>
            <div class="text-xs-center pt-2" v-if="!personal.photo">
              <v-icon color="grey" large>account_box</v-icon>
            </div>
          </v-flex>
          <v-flex xs8 md7>
            <v-card-title primary-title>
              <div>
                <div class="headline">{{ personal.firstName }} {{ personal.lastName }}</div>
                <v-divider class="my-2"></v-divider>
                <div><b>Nacionalidad:</b> {{ personal.country.name }}</div>
                <div><b>DNI:</b> {{ personal.dni || '-' }}</div>
                <div v-if="personal.pasaporte"><b>Pasaporte:</b> {{ personal.pasaporte }}</div>
                <div><b>Fecha de nacimiento:</b> {{ personal.dateOfBirth }}</div>
                <div v-if="!esWizardJugadores"><b>Rol:</b> {{ personal.rolDisplay }}</div>
              </div>
            </v-card-title>
          </v-flex>
        </v-layout>
      </v-card>
    </template>
    <div v-if="personal !== null" class="custom-font-light large-text custom-blue-text mb-1 mt-5">
      <v-icon color="grey">gavel</v-icon>
      <span style="font-size: large; margin-left: 5px;">Contratos</span>
    </div>
    <template v-if="personal !== null">
      <WizardContractsTable :contratosCombinados="[]" :pantallaFinal="false" @update:items="contratos = $event"
        :personal="personal" :club="personal.club">
      </WizardContractsTable>
    </template>
  </div>
</template>

<script>
import SelectPlayerActionButton from '../components/SelectPlayerActionButton.vue'
import DialogConfirmationPlayerFinal from './DialogConfirmationPlayerFinal.vue'
import WizardContractsTable from './WizardContractsTable.vue'

export default {
  components: { SelectPlayerActionButton, WizardContractsTable, DialogConfirmationPlayerFinal },
  props: {
    jugadorOriginal: {
      type: Object,
      default: () => null
    },
    esWizardJugadores: {
      type: Boolean,
      default: () => null
    }
  },
  data () {
    return {
      personal: null,
      path: 'playersWizard?',
      page_size: 10,
      page: 1,
      qSearch: '',
      filterPath: 'filters/players',
      search: '', // lo que escribís en el input
      items: [], // acá se guardan los datos de la búsqueda
      searchText: this.esWizardJugadores ? 'Buscar jugador' : 'Buscar personal',
      selectedPlayer: null, // aquí guardamos el jugador seleccionado
      pagination: {
        sortBy: 'firstName',
        descending: false,
        page: 1,
        rowsPerPage: 5,
        totalItems: 0
      },
      contratos: []
    }
  },

  computed: {
    headers () {
      let headers = [
        { text: 'Nombre', value: 'first_name', sortable: false },
        { text: 'Apellido', value: 'last_name', sortable: false },
        { text: 'DNI', value: 'dni', sortable: false },
        { text: 'Pasaporte', value: 'pasaporte', sortable: false },
        { text: 'País', value: 'country', sortable: false }
      ]
      if (!this.esWizardJugadores) {
        headers.push({ text: 'ID Personal', value: 'pk', sortable: false })
      } else {
        headers.push({ text: 'ID Jugador', value: 'pk', sortable: false })
      }
      if (!this.esWizardJugadores) {
        headers.push({ text: 'Rol', value: 'rol', sortable: false }
        )
      }
      headers.push({ text: 'Acciones', sortable: false }
      )
      return headers
    },
    properties () {
      let properties = ['player.lastName', 'player.firstName', 'status']
      return properties
    }
  },

  methods: {
    handlePlayerSelected (player) {
      if (this.jugadorOriginal !== null) {
        if (this.jugadorOriginal.player.pk === player.player.pk) {
          this.$refs.DialogConfirmationPlayerFinalRef.openDialogNewPlayer()
          return null
        } else {
          this.selectedPlayer = player
          this.fetchDataPlayer()
        }
      } else {
        this.selectedPlayer = player
        this.fetchDataPlayer()
      }
    },
    setItems (responseData) {
      this.items = responseData.results
    },
    onPaginationChange (newPagination) {
      this.pagination.page = newPagination.page
      this.buscarJugador()
    },
    fetchDataPlayer () {
      let path = 'playerTraerDatosWizard/'
      this.loading = true
      this.axios
        .get(path + this.selectedPlayer.player.pk)
        .then(response => {
          this.personal = response.data
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    async buscarJugador () {
      this.selectedPlayer = null
      this.loading = true
      if (!this.search) {
        this.items = []
        this.loading = false
        return
      }

      let params = {
        page: this.pagination.page,
        page_size: this.pagination.rowsPerPage,
        q: this.search
      }
      if (this.esWizardJugadores) {
        params.rol = 'jugador'
      } else {
        params.rol = 'ct'
      }

      try {
        const response = await this.axios.get(this.path, { params })
        this.items = response.data.results.map(item => ({
          player: item
        }))
        this.pagination = {
          ...this.pagination,
          totalItems: response.data.count
        }
        this.loading = false
      } catch (error) {
        /* this.loading = false
        let validError = error?.response?.data?.detail
        if (validError && error.response.data.detail.includes('Página inválida')) {
          this.pagination.page = 1
        } else {
          this.$store.commit('setErrorMsg', error)
        } */
      }
    }
  },
  watch: {
    contratos: {
      handler (newVal) {
        if (newVal) {
          this.$emit('update:items', newVal)
        }
      },
      deep: true,
      immediate: true
    },
    selectedPlayer: {
      handler (newVal) {
        if (newVal) {
          this.$emit('update:personal', newVal)
        }
      },
      deep: true,
      immediate: true
    },
    personal: {
      handler (newVal) {
        if (newVal) {
          this.$emit('update:photoPersonal', this.personal.photo)
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>
.spacing-top {
  margin-top: 6em !important;
}

.large-text {
  font-size: 1.8em;
}

.custom-blue-text {
  color: #293968;
}

.personal-button {
  width: 170px;
}

.condition-button {
  width: 240px;
}

.photo-button {
  width: 100%;
  height: 100%;
  max-height: 275px;
}
</style>
